import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useData } from '../../contexts/DataContext';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { data } = useData();
  const siteConfig = data.siteConfig;

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/profession', label: 'Category' },
    { path: '/blog', label: 'Blog' },
    { path: '/templates', label: 'Templates' },
    { path: '/contact', label: 'Contact' }
  ];

  // Function to properly handle logo URLs from Django admin
  const getLogoUrl = (url) => {
    if (!url) return null;
    
    // If it's already a full URL, return as is
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    
    // If it's a relative path, prepend the backend URL
    if (url.startsWith('/')) {
      return `http://localhost:8000${url}`;
    }
    
    // If it's just a filename, construct the path
    return `http://localhost:8000/media/site/${url}`;
  };

  const logoUrl = siteConfig?.logo ? getLogoUrl(siteConfig.logo) : null;

  return (
    <nav className="navbar">
      <div className="container nav-flex">
        <button 
          className={`toggle-btn ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        
        <div className="logo">
          <Link to="/" onClick={closeMenu}>
            {logoUrl ? (
              <img 
                src={logoUrl} 
                alt={siteConfig.site_name || "ResumeSlip"} 
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentNode.innerHTML = `<span>${siteConfig?.site_name || "ResumeSlip"}</span>`;
                }}
              />
            ) : (
              <span>{siteConfig?.site_name || "ResumeSlip"}</span>
            )}
          </Link>
        </div>
        
        <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          {navLinks.map((link) => (
            <li key={link.path}>
              <NavLink 
                to={link.path} 
                className={({ isActive }) => isActive ? 'active' : ''}
                onClick={closeMenu}
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
      <style jsx>{`
      .nav-links li a{
          text-decoration: none;
    font-size: 1rem;
    padding-bottom: 4px;
    position: relative;}

    .nav-links li a:hover::after {
    width: 100%;
    left: 50%;
}
    .nav-links li a::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 0%;
    height: 2px;
    background-color: currentColor;
    transition: width 0.4s ease, left 0.4s ease;
    transform: translateX(-50%);
}
      
      `}</style>
    </nav>
  );
};

export default Navbar;